<!--  -->
<template>
  <div class="back-top">
    <div class="back" @click="replacePath"></div>
    <div class="call_btn">
      <a href="tel:18001827959">
        <img class="call_btn_img" src="../assets/m/电话按钮.png" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "back-top",
  //import引入的组件需要注入到对象中才能使用
  components: {},

  data() {
    //这里存放数据
    return {};
  },

  //监听属性 类似于data概念
  computed: {},

  //监控data中的数据变化
  watch: {},

  //方法集合
  methods: {
    replacePath() {
      if (window.location.href.indexOf("m_index") > -1) {
        return window.scroll(0, 0);
      } else {
        this.$router.push("/m_index");
      }
    },
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang='less' scoped>
.back-top {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 12;
  display: flex;
  flex-flow: row-reverse nowrap;
  align-items: center;
  justify-content: center;
  .back {
    background: url("../assets/m/back-top.png") no-repeat;
    background-size: 100% 100%;
    width: 48px;
    height: 48px;
  }
  .call_btn {
    z-index: 999;
    a {
      display: block;
      margin-right: 8px;
      width: 5.6rem;
    }
    img {
      width: 100%;
    }
  }
}
</style>